import React from "react";
import { Typewriter } from "react-simple-typewriter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import GithubIcon from "@mui/icons-material/GitHub";
// import Link from "@mui/icons-material/Link";
import { Link } from "react-router-dom";
import "../styles/Home.css";

function Home() {
  const handleType = (count) => {
    // access word count number
    console.log(count);
  };

  const handleDone = () => {
    console.log(`Done after 5 loops!`);
  };

  return (
    <div className="home">
      <div className="about">
        <h2> Hi, My Name is Taha</h2>
        <div className="prompt">
          <p>
            A Front-End developer with a passion for
            <p style={{ color: "#e9d35b", fontWeight: "bold" }}>
              <Typewriter
                words={["Learning", "Designing", "Developing"]}
                loop={5}
                cursor
                cursorStyle=".."
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
                onLoopDone={handleDone}
                onType={handleType}
              />
            </p>
          </p>
          <a
            href="https://www.linkedin.com/in/taha-murtaza/"
            // className={classes.link}
            target="_blank"
          >
            <LinkedInIcon />
          </a>
          <a
            href="mailto:iamtahamurtaza@gmail.com"
            // className={classes.link}
            target="_blank"
          >
            <EmailIcon />
          </a>
          <a
            href="https://github.com/mtaha-21"
            // className={classes.link}
            target="_blank"
          >
            <GithubIcon />
          </a>
        </div>
      </div>
      <div className="skills">
        <h1> Skills</h1>
        <ol className="list">
          <li className="item">
            <h2> Front-End</h2>
            <span>
              React-Js, Redux, HTML, CSS, JavaScript, BootStrap, MaterialUI,
              TailwindCSS, StyledComponents, NPM.
            </span>
          </li>
          {/* <li className="item">
            <h2>Languages</h2>
            <span>JavaScript, Java, Python, C#, C, C++</span>
          </li> */}
        </ol>
      </div>
    </div>
  );
}

export default Home;
